import React, { useEffect } from 'react';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';

import * as actions from '../../../Store/Actions';
import {
  AuthCard,
  AuthDescription,
  AuthFooter,
  AuthKicker,
  AuthLink,
  AuthPage,
  AuthTitle,
} from '../../../Components/Auth/AuthLayout';
import { StyledForm } from '../../../Hoc/elements';
import Input from '../../../Components/UI/Forms/Inputs/Input';
import Button from '../../../Components/UI/Forms/Button/Button';
import Message from '../../../Components/UI/Messages/Message';

const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Adresse e-mail invalide.').required('Votre adresse e-mail est requise.'),
  password: Yup.string().required('Votre mot de passe est requis.').min(8, 'Minimum 8 caractères.'),
});

function Login({ cleanup, error, loading, login }) {
  useEffect(() => cleanup, [cleanup]);

  return (
    <AuthPage>
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={LoginSchema}
        validateOnMount
        onSubmit={async (values, { setSubmitting }) => {
          await login(values);
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, isValid }) => (
          <AuthCard>
            <AuthKicker>Heureux de vous revoir</AuthKicker>
            <AuthTitle>Connectez-vous à votre espace</AuthTitle>
            <AuthDescription>
              Retrouvez vos demandes, missions, documents et échanges en cours.
            </AuthDescription>
            <StyledForm noValidate>
              <Field
                type="email"
                name="email"
                label="Adresse e-mail"
                placeholder="vous@exemple.fr"
                autoComplete="email"
                component={Input}
              />
              <Field
                type="password"
                name="password"
                label="Mot de passe"
                placeholder="Votre mot de passe"
                autoComplete="current-password"
                component={Input}
              />
              <Button disabled={!isValid || isSubmitting} loading={loading ? 'Connexion…' : null} type="submit">
                Se connecter
              </Button>
              <AuthFooter>
                <AuthLink to="/recover">Mot de passe oublié ?</AuthLink>
              </AuthFooter>
              <AuthFooter>
                Pas encore de compte ? <AuthLink to="/signup">Créer un compte</AuthLink>
              </AuthFooter>
              <Message error show={Boolean(error)}>{error}</Message>
            </StyledForm>
          </AuthCard>
        )}
      </Formik>
    </AuthPage>
  );
}

const mapStateToProps = ({ auth }) => ({ loading: auth.loading, error: auth.error });
const mapDispatchToProps = { login: actions.signIn, cleanup: actions.cleanMessage };

export default connect(mapStateToProps, mapDispatchToProps)(Login);
